var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIsVegyes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H30V26C30 28.2091 28.2091 30 26 30H0V4Z",
    fill: "white",
    fillOpacity: 0.75
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_7909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8 6.2C22.9046 6.2 23.8 7.09543 23.8 8.2V21.8C23.8 22.9046 22.9046 23.8 21.8 23.8H8.2C7.09543 23.8 6.2 22.9046 6.2 21.8V8.2C6.2 7.09543 7.09543 6.2 8.2 6.2H21.8ZM26 6C26 4.89543 25.1046 4 24 4H6C4.89543 4 4 4.89543 4 6V24C4 25.1046 4.89543 26 6 26H24C25.1046 26 26 25.1046 26 24V6ZM15 8.4C11.359 8.4 8.4 11.359 8.4 15C8.4 18.641 11.359 21.6 15 21.6C18.641 21.6 21.6 18.641 21.6 15C21.6 11.359 18.641 8.4 15 8.4Z",
    fill: "#009900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_7909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsVegyes);
export default __webpack_public_path__ + "static/media/isVeg=yes.ed65eabc331042a8cd812e106d3c4adf.svg";
export { ForwardRef as ReactComponent };